<template>
  <div>
    <div
      v-for="[color, fontSize, fontWeight, textAlign] in classes"
      :key="color"
    >
      <div
        style="letter-spacing:normal !important; white-space: pre-line !important "
        :class="[color, fontSize, fontWeight, textAlign]"
      >
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    h1: Boolean, //32
    h2: Boolean, //24
    h3: Boolean, //20
    h4: Boolean, //18
    h5: Boolean, //16
    h6: Boolean, //14
    h7: Boolean, //12
    h8: Boolean, //10
    fontSize: String,
    regular: Boolean,
    medium: Boolean,
    semiBold: Boolean,
    bold: Boolean,
    left: Boolean,
    center: Boolean,
    right: Boolean,
    fontColor: String,
  },
  data() {
    return {
      label: this.label,
      classes: [],
    };
  },
  async mounted() {
    let Color;
    let FontSize;
    let FontWeight;
    let TextAlign;

    // class สี อยู่ที่ file app.scss ทั้งหมด ไปเรียกใช้ที่ันั้น
    if (this.fontColor) {
      Color = this.fontColor;
    } else {
      Color = "darkGrey";
    }

    // console.log(Color);
    // class fontSize อยู่ที่ file app.scss ทั้งหมด ไปเรียกใช้ที่ันั้น
    if (this.h1) {
      FontSize = `fs${this.fontSize ? this.fontSize : 32}`;
    } else if (this.h2) {
      FontSize = `fs${this.fontSize ? this.fontSize : 24}`;
    } else if (this.h3) {
      FontSize = `fs${this.fontSize ? this.fontSize : 20}`;
    } else if (this.h4) {
      FontSize = `fs${this.fontSize ? this.fontSize : 18}`;
    } else if (this.h5) {
      FontSize = `fs${this.fontSize ? this.fontSize : 16}`;
    } else if (this.h6) {
      FontSize = `fs${this.fontSize ? this.fontSize : 14}`;
    } else if (this.h7) {
      FontSize = `fs${this.fontSize ? this.fontSize : 12}`;
    } else if (this.h8) {
      FontSize = `fs${this.fontSize ? this.fontSize : 10}`;
    } else {
      FontSize = `fs${this.fontSize ? this.fontSize : 16}`;
    }

    if (this.fontSize) {
      FontSize = this.fontSize;
    }
    // class FontWeight อยู่ที่ file app.scss ทั้งหมด ไปเรียกใช้ที่ันั้น
    if (this.bold) {
      FontWeight = "bold";
    } else if (this.semiBold) {
      FontWeight = "semiBold";
    } else if (this.medium) {
      FontWeight = "medium";
    } else {
      FontWeight = "regular";
    }

    // class TextAlign อยู่ที่ file app.scss ทั้งหมด ไปเรียกใช้ที่ันั้น
    if (this.left) {
      TextAlign = "text-left";
    } else if (this.center) {
      TextAlign = "text-center";
    } else if (this.right) {
      TextAlign = "text-right";
    }

    this.classes = [
      [`${Color}`, `${FontSize}`, `${FontWeight}`, `${TextAlign}`],
    ];
  },
};
</script>

<style lang="scss" scoped></style>
